import React, { useEffect, useState } from "react";
import ReactApexChart from "react-apexcharts";

const MoodChart = ({ moodanalytics, currentRange }) => {
 
  const yLabels = ["No Response", "Terrible", "Bad", "Okay", "Great", "Amazing"];

  const [chartData, setChartData] = useState({
    series: [
      {
        name: "Desktops",
        data: [],
        markers: {
          size: 6,
          colors: "#F199BF",
          strokeColors: "#fff",
          strokeWidth: 2,
          hover: {
            size: 8,
          },
        },
      },
    ],
    options: {
      chart: {
        type: "area",
        zoom: {
          enabled: false,
        },
        toolbar: {
          show: false,
        },
      },
      dataLabels: {
        enabled: false,
      },
      stroke: {
        curve: "smooth",
        width: 1,
        lineCap: "round",
      },
      grid: {
        row: {
          colors: ["#f3f3f3", "transparent"],
          opacity: 0.5,
        },
        strokeDashArray: 0,
      },
      markers: {
        size: 1,
      },
      xaxis: {
        categories: ["M", "T", "W", "T", "F", "S", "S"],
      },
      yaxis: {
        labels: {
          //   show: false,
          //   formatter: function (value) {
          //     switch (value) {
          //       case 100:
          //         return "Terrible";
          //       case 41:
          //         return "Bad";
          //       case 35:
          //         return "Normal";
          //       case 51:
          //         return "Great";
          //       case 15:
          //         return "Amazing";
          //       default:
          //         return value;
          //     }
          //   },
        },
      },
      colors: ["#F199BF"],
      fill: {
        type: "gradient",
        gradient: {
          shadeIntensity: 1,
          opacityFrom: 0.7,
          opacityTo: 0.3,
          stops: [0, 90, 100],
        },
      },
    },
  });

  useEffect(() => {
    setChartData({
      series: [
        {
          name: "Mood",
          data: moodanalytics.map((e) => parseInt(e.dailymood)),
        },
      ],
      options: {
        chart: {
          type: "area",
          zoom: {
            enabled: false,
          },
          toolbar: {
            show: false,
          },
        },
        dataLabels: {
          enabled: false,
        },
        stroke: {
          curve: "straight",
          width: 1,
          lineCap: "round",
        },
        grid: {
          row: {
            colors: ["#f3f3f3"],
          },
          strokeDashArray: 0,
        },
        markers: {
          size: 1,
        },
        xaxis: {
          categories: moodanalytics.map((e) => e.label),
        },
        yaxis: {
          labels: {
            show: false,
            formatter: function (value) {
              return yLabels[parseInt(value)];
            },
          },
          tickAmount: 5,
          min:0,
          max:5
        },
        markers: {
          size: 6,
          colors: "#F199BF",
          strokeColors: "#fff",
          strokeWidth: 2,
          hover: {
            size: 8,
          },
        },
        colors: ["#F199BF"],
        fill: {
          type: "gradient",
          gradient: {
            shadeIntensity: 1,
            opacityFrom: 0.7,
            opacityTo: 0.3,
            stops: [0, 90, 100],
          },
        },
      },
    });

  }, [moodanalytics, currentRange]);

  return (
    <>
      <div id="chart" className="d-flex align-items-center justify-content-start mb-0">
        <ul className="moodchrts">
          <li>Amazing</li>
          <li>Good</li>
          <li>Okay</li>
          <li>Bad</li>
          <li>Terrible</li>
        </ul>
        <ReactApexChart
          options={chartData.options}
          series={chartData.series}
          type="area"
          height={200}
        />
      </div>
    </>
  );
};

export default MoodChart;
